import { User } from "../../types/user.types"
import apiService from "../api/api.service"

class PublicService {
    private static instance: PublicService;

    private constructor() {}

    public static getInstance(): PublicService {
        if (!PublicService.instance) {
            PublicService.instance = new PublicService();
        }
        return PublicService.instance;
    }

  /**
   * Create first admin user for a company with onboarding secret
   * @param companyId Company ID
   * @param adminData Admin user data
   * @param secret Company onboarding secret
   */
  public async addFirstAdmin(companyId: number, firstName: string, lastName: string, password: string,email: string, secret: string): Promise<User> {
    const requestBody = {
      firstName,
      lastName,
      password,
      email,
      companyId,
      secret
    };
    const response = await apiService.post<User>(`/public/companies/register-admin`, requestBody);
    return response;
  }
}

export default PublicService.getInstance();